import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import React from 'react';
import { useInput, ValidationError, Validator } from 'react-admin';

const RadioInput = ({
  source,
  validate,
  choices,
  row,
}: {
  source: string;
  validate?: Validator | Validator[];
  choices: {
    id: string;
    name: string;
    color?: string;
  }[];
  row?: boolean;
}) => {
  const { id, field, fieldState } = useInput({
    source,
    validate,
  });

  return (
    <FormControl fullWidth error={!!fieldState.error}>
      <RadioGroup
        id={id}
        name={field.name}
        onChange={field.onChange}
        onBlur={field.onBlur}
        value={field.value}
        row={row}
      >
        {choices.map((item, index) => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            ref={index === 0 ? field.ref : undefined}
            control={(
              <Radio
                sx={item.color ? {
                  color: item.color,
                  '&.Mui-checked': {
                    color: item.color,
                  },
                } : {}}
              />
            )}
            label={item.name}
          />
        ))}
      </RadioGroup>
      {fieldState.error && (
        <FormHelperText error>
          <ValidationError error={fieldState.error.message ?? ''} />
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default RadioInput;
